import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Shell, FormInput, AppConfig, BaseComponent, Redirection } from '@tytapp/common';
import { Subscription } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';
import { UserService } from '@tytapp/user';
import { ApiUser } from '@tytapp/api';
import { environment } from 'environments/environment';

export interface SettingsSection {
  id : string;
  label : string;
  hidden? : boolean;
  icon? : string;
  externalUrl? : string;
  openInNewTab? : boolean;
  sendToMainSite? : boolean;
  action? : Function;
  subpages? : SettingsSection[];
  doNotShowTopHeading? : boolean;
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent extends BaseComponent {

  constructor(
    private userService : UserService,
    private route : ActivatedRoute
  ) {
    super();
  }

  newEmail : string;

  changeEmail() {
  }

  private _userChangedSub : Subscription = null;

  justSignedOut = false;

  @FormInput()
  newsletter = false;

  get joinUrl() {
    return '/join';
  }

  membershipAccountUrl : SafeHtml;
  termsUrl : SafeHtml;
  privacyUrl : SafeHtml;

  user : ApiUser;
  sectionReady : boolean = false;

  isMainSection = false;

  get mainSettingsUrl() {
    return `${environment.urls.app}/settings`;
  }

  get mainSectionId(): string {

    let mainSectionId = this.sectionId;
    let secondarySectionId = null;

    if (this.sectionId.includes('/')) {
      mainSectionId = this.sectionId.replace(/\/.*/, '');
      secondarySectionId = this.sectionId.substr(mainSectionId.length);
    }

    return mainSectionId;
  }

  get secondarySectionId(): string {
    let secondarySectionId = null;

    if (this.sectionId.includes('/')) {
      let mainSectionId = this.sectionId.replace(/\/.*/, '');
      secondarySectionId = this.sectionId.substr(mainSectionId.length + 1);
    }

    return secondarySectionId;
  }

  sectionId = 'memberships';

  async init(reasonOrParams : string | Object = null) {
    let self = this;

    this.route.paramMap.subscribe(params => {
      this.sectionReady = false;
      this.isMainSection = !params.has('section');

      if (params.get('subsection') && params.get('section')) {
        this.sectionId = `${params.get('section')}/${params.get('subsection')}`;
      } else {
        this.sectionId = params.get('section') || 'memberships';
      }

      if (this.mainSectionId !== 'one-time-contribution') {
        let qp = this.route.snapshot.queryParamMap;
        let query = qp.keys.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(qp.get(key))}`).join('&');
        if (query != '')
          query = `?${query}`;
        window.location.replace(`${environment.urls.app}/settings/${this.sectionId}${query}`);
  
        return;
      }
  
      this.sectionReady = true;
    });

    this._userChangedSub = this.userService.userChanged.subscribe(async user => {
      if (!user && !this.justSignedOut) {
        this.userService.goToLogin();
        return;
      }

      this.user = user;
    });
  }

  destroy() {
    this._userChangedSub.unsubscribe();
  }
}
